export default __webpack_public_path__ + "static/media/blomming-1.1110f86d.png";